function r(n,r){return function(){for(var u=[],t=0;t<arguments.length;t++)u[t]=arguments[t];var e=n.find((function(n){return n[0].includes(r)}))||[],f=e[1];return f?f.apply(null,u):null}}

export { r as getRulePicker };
//# sourceMappingURL=getRulePicker.js.map
